import { useRef } from 'react';
import { useVideoScrub } from '../hooks/useVideoScrub';

export function VideoBackground() {
  const videoRef = useRef(null);
  useVideoScrub(videoRef);

  return (
    <video
      ref={videoRef}
      src="/animated.mp4"
      muted
      playsInline
      preload="auto"
      loop
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '70% center',
      }}
      aria-hidden="true"
    />
  );
}